import { parseISO, format } from 'date-fns';
const DateFormat = (props) => {
    return (format(parseISO(props.date), props.format ? props.format : "yyyy-MM-dd 'at' HH:mm"));
};
export default DateFormat;
